
$(function () {
  new Swiper(".swiper-infinite-items", {
    loop: true,
    freeMode: true,
    spaceBetween: 0,
    grabCursor: false,
    allowTouchMove: false,
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    freeMode: true,
    speed: 10000,
    freeModeMomentum: false
  });
});